import { createReducer } from 'redux-starter-kit';
import {
  SET_QESTIONNARES,
  SET_ANSWERS,
  SET_CUSTOMERS_RESPONSES,
  SET_IS_JOINED_CUSTOMER
} from './actions';
import { QuestionType } from './types';

interface StateType {
  questions: QuestionType[];
  answers: any;
  responses: any;
  isJoined: boolean;
}

const INITIAL_STATE = {
  questions: [],
  answers: {},
  responses: {},
  isJoined: false
};

export default createReducer(INITIAL_STATE, {
  [SET_QESTIONNARES]: (state, action) => {
    state.questions = action.payload.questions;
  },
  [SET_ANSWERS]: (state, action) => {
    state.answers = action.payload;
  },
  [SET_CUSTOMERS_RESPONSES]: (state, action) => {
    state.responses = action.payload;
  },
  [SET_IS_JOINED_CUSTOMER]: (state, action) => {
    state.isJoined = action.payload;
  }
});
